import React, { FC } from 'react';

import { IWebLink } from '../../../../../../../../types';
import Link from '../../../../atoms/Link';
import Menu from './molecules/Menu';

import styles from './index.module.sass';

interface LinksProps {
  header?: IWebLink[];
}

const Links: FC<LinksProps> = ({ header = []}) =>
  header?.length > 0 ? (
    <ul className={styles.links}>
      {header?.map(( link ) => (
        <li className={styles.item} key={`${link.id}${link.label}`}>
          {link.children ? (
            <Menu links={link.children}>{link.label}</Menu>
          ) : (
            <Link className={styles.link} href={link.url}>
              {link.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  ) : null;

export default Links;
